import {useThree, useFrame } from "@react-three/fiber";
import {useEffect,useState,useRef} from "react";

function Box(props){
    const mesh = useRef();

    useFrame(() => {
        mesh.current.rotation.y = mesh.current.rotation.x -= 0.01;
    });

    return(
        <mesh ref={mesh} position={[props.xyz[0],props.xyz[1],props.xyz[2]]} rotation={[(-Math.PI / 2),0,0]}>
            <boxBufferGeometry attach="geometry"/>
            <meshLambertMaterial attach="material" color="#056D65" />
        </mesh>
    )
}

function ConeShape(props) {
    const mesh = useRef();
    useFrame(() => {
        mesh.current.rotation.y = mesh.current.rotation.x -= 0.01;
    });
    return (
        <mesh ref={mesh} position={[props.xyz[0],props.xyz[1],props.xyz[2]]} scale={(0.5, 0.5, 0.8)}>
            <coneGeometry
                attach="geometry"
                args={[1, 2.5, 3]}
                smoothness={5}
                {...props}/>
            <meshPhongMaterial
                color="#D8F0EE"
                attach="material"
                transparent
                roughness={0.1}
                metalness={0.1}/>
        </mesh>
    );
}

function Sphere(props) {
    const mesh = useRef();
    useFrame(() => {
        mesh.current.rotation.y+=0.01
        mesh.current.rotation.x -= 0.01;
        mesh.current.rotation.z += 0.01;
    });
    return (
        <mesh ref={mesh} visible position={[props.xz[0], 0, props.xz[1]]} castShadow>
            <sphereGeometry attach="geometry" args={[1, 16, 16]} />
            <meshStandardMaterial
                wireframe
                color="white"
                roughness={0.1}
                metalness={0.1}
            />
        </mesh>
    );
}




const deg2rad = degrees => degrees * (Math.PI / 180);
export default function Shapes(){

    const [cubexyz,setCubexyz] = useState([-7,-5,0])
    const [prismxyz,setPrismxyz] = useState([-8,-8,-6])
    const [spherexz,setSpherexz] = useState([-5,0])

    function checkScroll(e){
        let scroll = window.scrollY
        if(scroll === 0) scroll = 0.01
        let windowHeight = window.innerHeight

        let calc = ((scroll/windowHeight))
        let x = ( calc * -14) + 7
        let y = (calc * -10) + 5
        let z = (calc * 3)
        // console.log(x,y)

        setCubexyz([x,y,z])

        x = (calc * 11)-8
        y = (calc * 8)-8
        z = (calc * 10)-6

        setPrismxyz([x,y,z])

        x = (calc * 4.5) - 5
        z = (calc * 4)

        setSpherexz([x,z])

    }
    useEffect(()=>{
        document.addEventListener('scroll',checkScroll)
    },[])

    useThree(({camera})=>{
        camera.rotation.set(deg2rad(-5),0,0)
    })
    return(<>
        {/*<OrbitControls/>*/}
        <ambientLight intensity={0.1}/>
        {/*<spotLight position={[10,15,10]} angle={0.3}/>*/}
        <pointLight position={[5, 20, 30]} />
        <Box xyz={cubexyz}/>
        <ConeShape xyz={prismxyz}/>
        <Sphere xz={spherexz}/>
        </>)
}